import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "700pt",
  height: "700pt",
  viewBox: "0 0 700 700"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m375.443 329.558 204.896-204.575a32.66 32.66 0 0 0 8.456-31.547 32.68 32.68 0 0 0-23.09-23.09 32.66 32.66 0 0 0-31.548 8.457L329.583 283.698 125.009 78.803a32.66 32.66 0 0 0-31.547-8.457 32.68 32.68 0 0 0-23.09 23.09 32.65 32.65 0 0 0 8.455 31.547l204.895 204.575L78.827 534.132a32.53 32.53 0 0 0-9.621 23.09 32.5 32.5 0 0 0 9.621 23.091 32.51 32.51 0 0 0 23.09 9.621 32.53 32.53 0 0 0 23.091-9.621l204.574-204.895 204.574 204.895a32.53 32.53 0 0 0 23.091 9.621 32.51 32.51 0 0 0 23.091-9.621 32.524 32.524 0 0 0 0-46.181z" }, null, -1)
  ])))
}
export default { render: render }